"use client";

import { ComponentPropsWithoutRef, MouseEvent } from "react";

let popstateHandler: (() => void) | null = null;
let widgetCloseListenerRegistered = false;
let closedByBackButton = false;

const cleanup = () => {
    if (popstateHandler) {
        window.removeEventListener("popstate", popstateHandler);
        popstateHandler = null;
    }
};

export const openSupportWidget = () => {
    if (typeof window === "undefined") return;
    if (typeof window.FreshworksWidget === "function") {
        // Push history state so back button closes the widget instead of navigating
        window.history.pushState({ supportWidget: true }, "");
        closedByBackButton = false;

        popstateHandler = () => {
            closedByBackButton = true;
            cleanup();
            window.FreshworksWidget("close");
        };
        window.addEventListener("popstate", popstateHandler);

        // Register widget:closed listener only once
        if (!widgetCloseListenerRegistered) {
            widgetCloseListenerRegistered = true;
            window.FreshworksWidget("on", "widget:closed", () => {
                if (!closedByBackButton && popstateHandler) {
                    cleanup();
                    // Remove our history entry since user closed manually
                    if (window.history.state?.supportWidget) {
                        window.history.back();
                    }
                }
                closedByBackButton = false;
            });
        }

        window.FreshworksWidget("open");
        return;
    }
    if (window.NativeBridge?.openUrlInBrowser) {
        window.NativeBridge.openUrlInBrowser("https://support.tixu.ai/");
        return;
    }
    window.location.href = "mailto:support@tixu.ai";
};

type SupportWidgetButtonProps = ComponentPropsWithoutRef<"button">;

export const SupportWidgetButton = ({ type, onClick, children, ...rest }: SupportWidgetButtonProps) => {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);
        if (event.defaultPrevented) return;
        openSupportWidget();
    };

    return (
        <button type={type ?? "button"} onClick={handleClick} {...rest}>
            {children}
        </button>
    );
};
